import { selectAll, select, addClass, removeClass } from 'helpers/dom'

const selectors = {
  ITEM_SELECTOR: '.js-accordion-item',
  BUTTON_SELECTOR: '.js-accordion-button',
  CONTENT_SELECTOR: '.js-accordion-content',
  HEADING_BUTTON_CLASS: '.js-accordion-button .text',
  VIDEO_PLAYER_SELECTOR: 'video-player',
  LOAD_MORE_SELECTOR: '.js-load-more',
  ACTIVE_CLASS: 'active'
}

class AccordionList extends HTMLElement {
  constructor() {
    super()

    this.videoPlayers = selectAll(selectors.VIDEO_PLAYER_SELECTOR, this)
    this.init()
  }

  close(items) {
    items.forEach((item) => {
      const content = item.querySelector(selectors.CONTENT_SELECTOR)
      const button = item.querySelector(selectors.BUTTON_SELECTOR)

      if (button && content) {
        content.style.maxHeight = '0px'
        button.setAttribute('aria-expanded', 'false')
        item.removeAttribute('open')
      }

      if (this.videoPlayers.length) {
        this.videoPlayers.forEach((video) => {
          if (video) {
            video.pause()
          }
        })
      }
    })
  }

  open(item) {
    const content = item.querySelector(selectors.CONTENT_SELECTOR)
    const button = item.querySelector(selectors.BUTTON_SELECTOR)

    content.style.maxHeight = content.children[0].scrollHeight + 'px'
    button.setAttribute('aria-expanded', 'true')
    item.setAttribute('open', true)
  }

  toggleDescription(item, list) {
    if (item && !item.hasAttribute('open')) {
      this.close(list)
      this.open(item)
    } else {
      this.close(list)
    }
  }

  init() {
    const list = this.querySelectorAll(selectors.ITEM_SELECTOR)
    const loadMoreEls = selectAll(selectors.LOAD_MORE_SELECTOR)

    if (list.length) {
      list.forEach((item) => {
        const button = item.querySelector(selectors.BUTTON_SELECTOR)
        const textTitle = item.querySelector(selectors.HEADING_BUTTON_CLASS)

        if (textTitle) {
          textTitle.innerHTML = textTitle.innerHTML.replace(
            /(^\w|\s\w)(\S*)/g,
            (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
          )
        }

        if (item.hasAttribute('open')) {
          this.open(item)
        }

        if (button) {
          const _this = this

          button.onclick = function (e) {
            if (location.pathname.includes('store-locator')) {
              e.stopPropagation()
            }
            _this.toggleDescription(item, list)
          }
        }

        if (loadMoreEls.length > 0) {
          loadMoreEls.forEach(function (more) {
            if (list.length > 4) {
              addClass(selectors.ACTIVE_CLASS, more)
              more.addEventListener('click', (evt) => {
                evt.preventDefault()

                addClass(selectors.ACTIVE_CLASS, item)
                removeClass(selectors.ACTIVE_CLASS, more)
              })
            }
          })
        }
      })

      if (loadMoreEls.length > 0) {
        const faqAccordions = document.querySelectorAll('.accordion-faq')

        loadMoreEls.forEach(function (el) {
          el.addEventListener('click', (evt) => {
            if (faqAccordions.length < 4) {
              evt.preventDefault()
              if (window.GM_STATE.shopify.templateSuffix === 'bundle' || window.GM_STATE.shopify.templateSuffix === 'bundle-extra-sections') return
              window.location.href = `${window.Shopify.routes.root}pages/faqs`
            } else {
              evt.preventDefault()
              addClass(selectors.ACTIVE_CLASS, list)
              removeClass(selectors.ACTIVE_CLASS, el)
            }
          })
        })
      }
    }
  }
}

if (!customElements.get('accordion-list')) {
  customElements.define('accordion-list', AccordionList)
}
